import { Option } from '~/types/CommonTypes';
import i18n from '~modules/i18n';

const { t } = i18n.global;

const createCommissionStatus = (
  color: 'warn' | 'success' | 'danger' | 'info' | 'help',
  content: string,
  tip: string,
) => ({ color, content, tip });

export const COMMISSION_STATUS = {
  AVAILABLE: createCommissionStatus(
    'success',
    'COMMISSIONS.STATUS.AVAILABLE.LABEL',
    'COMMISSIONS.STATUS.AVAILABLE.TIP',
  ),
  CREDITED: createCommissionStatus(
    'success',
    'COMMISSIONS.STATUS.CREDITED.LABEL',
    'COMMISSIONS.STATUS.CREDITED.TIP',
  ),
  DEDUCTED: createCommissionStatus(
    'danger',
    'COMMISSIONS.STATUS.DEDUCTED.LABEL',
    'COMMISSIONS.STATUS.DEDUCTED.TIP',
  ),
  DEBITED: createCommissionStatus(
    'danger',
    'COMMISSIONS.STATUS.DEBITED.LABEL',
    'COMMISSIONS.STATUS.DEBITED.TIP',
  ),
  CANCELED: createCommissionStatus(
    'danger',
    'COMMISSIONS.STATUS.CANCELED.LABEL',
    'COMMISSIONS.STATUS.CANCELED.TIP',
  ),
  PREVIEW: createCommissionStatus(
    'warn',
    'COMMISSIONS.STATUS.PREVIEW.LABEL',
    'COMMISSIONS.STATUS.PREVIEW.TIP',
  ),
};

export const commissionStatusOptions: Option[] = Object.entries(COMMISSION_STATUS).map(
  ([key, value]) => ({
    value: key,
    label: t(value.content),
  }),
);
